import React from 'react';
import { useTranslation } from 'react-i18next';
import PrivateIcon from '@wix/da-ds/pkg/Icons/16x16/Private';
import useDeviationStats from '../useDeviationStats';
import Stat from '../Stat';
const PrivateCollectionStat = ({ deviation, onlyNumbers, className })=>{
    const { t } = useTranslation();
    const { privatelyCollected } = useDeviationStats(deviation);
    if (!privatelyCollected) {
        return null;
    }
    return /*#__PURE__*/ React.createElement(Stat, {
        className: className,
        deviation: deviation,
        icon: PrivateIcon,
        statNameLocaleKey: "deviation.stats.privateCollections",
        statCount: privatelyCollected,
        onlyNumbers: onlyNumbers,
        title: t('deviation.stats.tooltip.privateCollections')
    });
};
PrivateCollectionStat.displayName = 'PrivateCollectionStat';
export default PrivateCollectionStat;

//# sourceMappingURL=PrivateCollectionsStat.js.map